import { 
  labResultMap,
  labResults,
  coldBinMap,
  coldBinReadings,
} from '@/mock/minds.json'

export default {
  selectedPlant: (state) => {
    return state.plants.find((aS) => aS._id === state.selectedPlantId)
  },
  selectedAsphaltMix: (state, getters) => {
    return getters.plantAsphaltMixes.find(
      (m) => m._id === state.selectedAsphaltMixId,
    )
  },
  plantAsphaltMixes: (state, getters) => {
    return state.asphaltMixes.filter(
      (m) => m.plantId === state.selectedPlantId,
    )
  },
  asphaltMixLabResults: (state, getters) => {
    let mixCode = getters.selectedAsphaltMix?.mixDesignCode;
    return labResultMap.find(x => x.mixCode == mixCode)?.labResults || labResults
  },
  asphaltMixColdBinReadings: (state, getters) => {
    let mixCode = getters.selectedAsphaltMix?.mixDesignCode;
    return coldBinMap.find(x => x.mixCode == mixCode)?.coldBinReadings || coldBinReadings
  },
}
